/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useState, useEffect, useContext, useRef } from "react";
import { useHistory } from 'react-router-dom';
import { Field, Form, Formik } from 'formik';
import Layout from "components/Layout/index";
import SubTitle from "components/SubTitle";
import ContentCard from "components/ContentCard";
import Button, { ButtonContainer } from 'components/Button';
import FileModal from "components/FileModal";
import BrokingSummary from "components/BrokingSummary";
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import { GlobalLoaderContext } from 'store/context';
import { GlobalAuthContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import { LostCancelButton } from 'components/index';
import StepNavigation from "components/StepNavigation/index";
import * as yup from 'yup';
import {
  CalendarContainer, ButtonContent,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCollum,
  InlineLabel,
  LabelEdit
} from "./styles";
import { GridColumnTitle } from "components/Form";
import HasPermission from "components/HasPermission/index";
import { Col, Row } from 'components/Grid';
import { Label, InputField } from "components/Form";
import { endorsementTypesEnum } from './endorsementTypesEnum';
import CheckBox from "components/Form/CheckBox";
import {useCreatePolicyPack, useWordingSendApproval, useHeaderNbi, useEndorsementSigners} from 'services/QuoteService';
import { useOperationInfo } from 'services/OperationService';
import {
  useGetQuestionnaireAnswer,
  useSaveQuestionnaireAnswerSync
} from "services/QuestionnaireAnswerService";
import { GeneralSection, EndorsementTypesSection } from "./sections/index";

export default function EndorsementNotPreAgreed(props) {
  const [file, setFile] = useState();
  const [summary, setSummary] = useState({});
  const [endorsmentType, setEndorsmentType] = useState("");
  const [isBound, setIsBound] = useState(false);

  const authContext = useContext(GlobalAuthContext);
  const formik = useRef(null);
  const history = useHistory();

  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const loading = useContext(GlobalLoaderContext);
  const refQuestionnaireSent = useRef(false);

  const [canGeneratePack, setCanGeneratePack] = useState(false);
  const [selectedTypesEndorsement, setSelectedTypesEndorsement] = useState([])
  const [signers, setSigners] = useState([]);
  const [validation, setValidation] = useState({});
  const [rejectDocuments, setRejectDocuments] = useState(false);
  const [idDomainOperation, setIdDomainOperation] = useState(false);
  const [questionnaire, setQuestionnaire] = useState([]);
  const [operation, setOperation] = useState(null);

  let SECTIONS = {
    ENDORSEMENT_TYPES: { name: "ENDORSEMENT_TYPES", isMultiple: false, isRisk: false },
  };

  const endorsementTypesAllowed = [
    'pre-agreed', 'not-pre-agreed',
    'adjustments-and-corrections', 'market-changes',
    'cancellation', 'off-risk', 'policy-extension',
    'client-change'
  ];

  const {
    data: useCreatePolicyPackData,
    loading: useCreatePolicyPackLoading,
    error: useCreatePolicyPackError,
    status: useCreatePolicyPackStatus,
    request: useCreatePolicyPackRequest,
  } = useCreatePolicyPack(props.match.params.idOperation);

  const {
    data: useWordingSendApprovalData,
    loading: useWordingSendApprovalLoading,
    error: useWordingSendApprovalError,
    status: useWordingSendApprovalStatus,
    request: useWordingSendApprovalRequest,
  } = useWordingSendApproval();

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: useOperationInfoData,
    loading: useOperationInfoLoading,
    error: useOperationInfoError,
    status: useOperationInfoStatus,
    request: useOperationInfoRequest,
  } = useOperationInfo(props.match.params.idOperation);

  const {
    data: useEndorsementSignersData,
    loading: useEndorsementSignersLoading,
    error: useEndorsementSignersError,
    status: useEndorsementSignersStatus,
    request: useEndorsementSignersRequest,
  } = useEndorsementSigners(props.match.params.idOperation);

  const {
    data: useGetQuestionnaireAnswerData,
    loading: useGetQuestionnaireAnswerLoading,
    error: useGetQuestionnaireAnswerError,
    status: useGetQuestionnaireAnswerStatus,
    request: useGetQuestionnaireAnswerRequest
  } = useGetQuestionnaireAnswer(props.match.params.idOperation);

  const {
    data: useSaveQuestionnaireAnswerData,
    loading: useSaveQuestionnaireAnswerLoading,
    error: useSaveQuestionnaireAnswerError,
    status: useSaveQuestionnaireAnswerStatus,
    request: useSaveQuestionnaireAnswerRequest
  } = useSaveQuestionnaireAnswerSync(props.match.params.idOperation);

  useEffect(() => {
    if (
      useCreatePolicyPackLoading ||
      useWordingSendApprovalLoading ||
      useHeaderNbiLoading ||
      useOperationInfoLoading ||
      useEndorsementSignersLoading ||
      useGetQuestionnaireAnswerLoading ||
      useSaveQuestionnaireAnswerLoading
    ) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [
    useCreatePolicyPackLoading,
    useWordingSendApprovalLoading,
    useHeaderNbiLoading,
    useOperationInfoLoading,
    useEndorsementSignersLoading,
    useGetQuestionnaireAnswerLoading,
    useSaveQuestionnaireAnswerLoading
  ]);

  useEffect(() => {
    if ( useGetQuestionnaireAnswerStatus === 200) {
      handleQuestionnaire(useGetQuestionnaireAnswerData?.value);
    }
  }, [useGetQuestionnaireAnswerStatus]);

  const handleQuestionnaire = (data) => {
    let questionnaires = [
      ...data.operations,
    ].sort((a, b) => a.sequenceQuestion - b.seQuenceQuestion);

    questionnaires = EndorsementTypesSection.events.handleInitialAdjustments({ questionnaire: questionnaires });

    setQuestionnaire(questionnaires);
  };

  async function handleGetSigners() {
    useEndorsementSignersRequest().then(({data: response}) => {
        if (response.ret_code !== 200) {
          return;
        }

        const validationSchema = {};
        const signersFiltered = response.ret_value?.map(signer => ({
          ...signer,
          facilities: signer.facilities
            .map(facility => {
              if (facility.textTabValue) {
                formik.current?.setFieldValue(`reference_number_${signer.idPerson}_${facility.idQuestionnaireAnswer}`, facility.textTabValue == "---------------" ? "" : facility.textTabValue )
                validationSchema[`reference_number_${signer.idPerson}_${facility.idQuestionnaireAnswer}`] = yup.string().required('* Required field').max(15, 'Limited to 15 caracters');
              }
              return facility;
            })
        }))

        buildValidation(validationSchema);
        setSigners(signersFiltered);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleGetSigners.name}\n` + error);
      });
  }

  const handleSendApproval = () => {
    let signersValues = signers.map((signer) => ({
      ...signer,
      facilities: signer.facilities.map(facility => ({
        ...facility,
        textTabValue: formik.current.values[`reference_number_${signer.idPerson}_${facility.idQuestionnaireAnswer}`] || facility.textTabValue
      }))
    }));

    useWordingSendApprovalRequest(
      { idOperation: props.match.params.idOperation,
        policyPackMessage: formik.current.values.policyPackMessage, 
        effectiveDate: formik.current.values.effectiveDate, 
        selectedTypesEndorsement: selectedTypesEndorsement, 
        signers: signersValues
      }, null)
      .then(({data}) => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          return;
        }
        history.push(`/broking/approval-policy-pack/${props.match.params.idOperation}`);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSendApproval.name}\n` + error);
        console.error('fitPostReject - Error:', error);
      });
  }

  function handleSummary() {
    useHeaderNbiRequest({idOperation: props.match.params.idOperation}, null).then(({data}) => {
        setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          projectName: data.ret_value.projectName,
          idOperation: props.match.params.idOperation,
        });

        setEndorsmentType(data.ret_value.endorsmentType);
        handleGetModal(data.ret_value.endorsmentType);
      })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostSummary - Error:', error);
      });
  };


  function handlePolicyPack() {
    useCreatePolicyPackRequest({extraDocuments: null}, null).then(({data}) => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          return;
        }
        handleSendApproval()
      })
      .catch((error) => {
        mc.error(error);
        console.error('fitPostReject - Error:', error);
      });
  }

  function handleGetModal(endorsment = endorsmentType) {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.endorsementDocHtmlModal(props.match.params.idOperation, endorsment)
      .then(x => x.json())
      .then(resp => {
        if (resp.ret_code === 200) {
          setFile(resp.ret_value)
        } else {
          setFile(null)
        }
      }).catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostReject - Error:', error);
      });
  };

  const goToLoginPage = () => {
    history.push('login');
  };

  async function handleOperationInfo() {
    useOperationInfoRequest().then(({data: response}) => {
        setIsBound(response?.isBound);
        setOperation(response);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleOperationInfo.name}\n` + error);
      });
  }
  async function handleUpdateEndersementReport(property, value) {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestUpdateEndersementReport(props.match.params.idOperation, property, value)
      .then(response => response.json())
      .then(response => {
        if (response.ret_code === 200) {
          setFile(null)
          handleGetModal();
          loading.stop();
        } else {
          mc.error(response.ret_msg_details);
          loading.stop();
        }
      })
      .catch((error) => {
        loading.stop();
        mc.error("There was an error while updating endersment date: \n" + error);
        console.error('fitPostReject - Error:', error);
      });
  }

  const renderUWReferenceByInsurer = (formikProps) => {
    if (!signers.length) return <div />

    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableHeader>
              <GridColumnTitle>
                Insurer Name
              </GridColumnTitle>
            </TableHeader>
            <TableHeader>
              <GridColumnTitle>
                UW Reference
              </GridColumnTitle>
            </TableHeader>
          </TableRow>
        </TableHead>

        <TableBody>
          {signers.map((signer, index) => (
            <TableRow>
              <TableCollum>
                <InlineLabel>
                  Insurer Name
                </InlineLabel>
                <LabelEdit>
                  {signer?.party}
                </LabelEdit>
              </TableCollum>

              <TableRow>
                <TableCollum style={{ width: 400 }}>
                  {signer.facilities.map((facility, index) => {
                    if (facility.textTabValue) {
                    return (
                      <>
                        <InlineLabel>
                          Facility
                        </InlineLabel>
                        <LabelEdit>
                          {facility?.name}
                        </LabelEdit>

                        <Field
                          style={{ minWidth: 100 }}
                          name={`reference_number_${signer.idPerson}_${facility.idQuestionnaireAnswer}`}
                          value={formikProps.values?.[`reference_number_${signer.idPerson}_${facility.idQuestionnaireAnswer}`]}
                          onChange={(e) => formikProps?.setFieldValue(`reference_number_${signer.idPerson}_${facility.idQuestionnaireAnswer}`, e)}
                          component={InputField}
                          onBlur={async () => {
                            if (formikProps.errors[`reference_number_${signer.idPerson}_${facility.idQuestionnaireAnswer}`]) {
                              mc.error('Please fill the field correctly')
                              return;
                            }

                            let signersValues = signers.map((signer) => ({
                              ...signer,
                              facilities: signer.facilities.map(facility => ({
                                ...facility,
                                textTabValue: formik.current.values[`reference_number_${signer.idPerson}_${facility.idQuestionnaireAnswer}`] || facility.textTabValue
                              }))
                            }));

                            handleUpdateEndersementReport('signers', signersValues);

                          }}
                        />
                      </>
                    )
                    }
                  })}
                </TableCollum>
              </TableRow>

            </TableRow>
          ))}
        </TableBody>
      </Table>
    )
  }

  const buildValidation = (extraValidation = {}) => {
    const validationSchema = {
      policyPackMessage: yup.string().required("* Required field"),
      effectiveDate: endorsmentType ? yup.string().required('* Required field') : yup.string().nullable(),
      ...extraValidation,
    }

    setValidation(yup.object().shape(validationSchema))
  }

  const handleEnable = () => {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.wordingAttachments(props.match.params.idOperation).then(x => x.json()).then(res => {
      if (res.ret_code != 200) {
        return;
      }
    });
  }

  async function handleUpdateSelectedTypesEndorsement(type) {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestUpdateSelectedTypesEndorsement(props.match.params.idOperation, type)
      .then(response => response.json())
      .then(response => {
        if (response.ret_code === 200) {
          setFile(null)
          handleGetModal();
        } else {
          mc.error(response.ret_msg_details);
        }
      })
      .catch((error) => {
        mc.error("There was an error while updating the endorsement item: \n" + error);
        console.error('fitPostReject - Error:', error);
      });
  }

  const SubmitButton = () => {
    if (!endorsmentType && rejectDocuments) {
      return (
        <HasPermission permission={props.permissions.GENERATE_WORDING}>
          <Button
            style={{ marginLeft: "10px", marginTop: "5px" }}
            primary
            type="submit"
            id="btnSubmit"
            onClick={() => { history.go('/list'); }}
          >
            GENERATE WORDING
          </Button>
        </HasPermission>
      )
    }
    if ((canGeneratePack || !endorsmentType) && !rejectDocuments) {
      const operation = idDomainOperation && (idDomainOperation === 253 || idDomainOperation === 254 || idDomainOperation === 624 || idDomainOperation === 395);
      return (
        <HasPermission permission={props.permissions.POLICY_PACK_SEND_INTERNALLY || (endorsmentType && props.permissions.ENDORSEMENT_PACK_SEND_INTERNALLY)}>
          <Button
            style={{ marginLeft: "10px", marginTop: "5px" }}
            primary
            type="submit"
            id="btnSubmit"
            onClick={() => operation ? history.push(`/broking/stamp-request-contacts/${props.match.params.idOperation}`) : history.push(`/broking/send-order-to-bind/${props.match.params.idOperation}`)}
          >
            {operation ? 'STAMPS' : 'ORDER TO BIND'}
          </Button>
        </HasPermission>
      )
    }

    return <div />
  }

  useEffect(() => {
    if (endorsmentType === 'adjustments-and-corrections' || endorsmentType === 'client-change') {
      handleGetSigners();
    }
  }, [endorsmentType])

  useEffect(() => {
    if (selectedTypesEndorsement.length === 0) {
      return;
    }
    else {
      handleUpdateSelectedTypesEndorsement(selectedTypesEndorsement)
    }
  }, [selectedTypesEndorsement])

  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);

    handleGetModal();
    handleEnable();
    buildValidation();
    handleOperationInfo();
    handleSummary();
    useGetQuestionnaireAnswerRequest();
  }, [])

  return (
    <Layout
      idOperation={props.match?.params?.idOperation}
      title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"}
      subtitle={summary.dealCode ? summary.dealCode : "Broking code"}>
      <StepNavigation stage={3} idOperation={props.match?.params?.idOperation} />
      <BrokingSummary data={summary} />

      <ContentCard title={'ENDORSEMENT DOCUMENT'} icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>
        <Formik
          innerRef={formik}
          initialValues={{}}
          validationSchema={validation}
          onSubmit={() => handleSendApproval()}>
          {formikProps => (
            <Form>
              {endorsmentType ? (
                <EndorsementTypesSection.components.RenderSection
                  formikProps={ formikProps }
                  formikRef={ formik }
                  idOperation={props.match?.params?.idOperation}
                  idOperationParent={props.match?.params?.idOperationParent}
                  globalQuestionnaire={ questionnaire }
                  idDomainOperation={operation?.idDomain}
                />
              ) : null
              }
              {renderUWReferenceByInsurer(formikProps)}
              {file?.length && <FileModal idOperation={props?.match?.params?.idOperation} file={file} />}
              <ButtonContainer>
                <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
                <HasPermission permission={!isBound}>
                  <ButtonContent>
                    <div style={{ marginTop: "5px" }}>
                      <LostCancelButton idOperation={props.match?.params?.idOperation} />
                    </div>
                    <Button
                      primary
                      style={{ marginLeft: "10px", marginTop: "5px" }}
                      name="SEND APPROVAL"
                      id="mktComposition"
                      onClick={(e) => { e.preventDefault(); e.stopPropagation(); GeneralSection.events.handleSave({
                        idOperation: props.match?.params?.idOperation,
                        idOperationParent: props.match?.params?.idOperationParent,
                        formikRef: formik,
                        mc,
                        questionnaire,
                        refQuestionnaireSent,
                        SECTIONS,
                        useGetQuestionnaireAnswerRequest,
                        useSaveQuestionnaireAnswerRequest,
                        submitFunction: handlePolicyPack,
                        values: formikProps.values
                      }) }}
                    >
                      ENDORSEMENT PACK
                    </Button>
                  </ButtonContent>
                </HasPermission>
              </ButtonContainer>
            </Form>
          )}
        </Formik>
      </ContentCard>
      {loading.active && (<Loader backdropColor={Colors.WHITE} fullScreen />)}
    </Layout>
  );
}
